/**
 * Data type 'text'
 *
 * This is the default type and has no special features.
 */
export default {};	



// WEBPACK FOOTER //
// ./src/types/text.js